import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=1c5a6cac&scoped=true"
import script from "./Column.vue?vue&type=script&lang=ts"
export * from "./Column.vue?vue&type=script&lang=ts"
import style0 from "./Column.vue?vue&type=style&index=0&id=1c5a6cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5a6cac",
  null
  
)

export default component.exports